import * as yup from 'yup';
import phone from '../../phone';
const setPhoneNumber = yup
    .object()
    .shape({
    mobile: phone.required('This field is required')
})
    .defined();
export default setPhoneNumber;
//# sourceMappingURL=index.js.map